var map = {
	"./account.banqup.json": "./src/configs/account.banqup.json",
	"./bank.json": "./src/configs/bank.json",
	"./banqup.json": "./src/configs/banqup.json",
	"./dbc.json": "./src/configs/dbc.json",
	"./energy_shr.json": "./src/configs/energy_shr.json",
	"./fmdm.json": "./src/configs/fmdm.json",
	"./identity.banqup.json": "./src/configs/identity.banqup.json",
	"./knb.json": "./src/configs/knb.json",
	"./kvk.json": "./src/configs/kvk.json",
	"./legal-entity.banqup.json": "./src/configs/legal-entity.banqup.json",
	"./local-dev.json": "./src/configs/local-dev.json",
	"./nglr.json": "./src/configs/nglr.json",
	"./notary.json": "./src/configs/notary.json",
	"./sphereon.json": "./src/configs/sphereon.json",
	"./triall.json": "./src/configs/triall.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/configs sync recursive ^\\.\\/.*\\.json$";